import React, {Component, createContext} from 'react';

const PicklistContext = createContext();

function withPickList ( PickListComponent ) {
    function Wrapper ( props ) {
        return (
            <PicklistContext.Consumer>
                {contextValue =>
                    <PickListComponent pickList={{...contextValue}} {...props} />
                }
            </PicklistContext.Consumer>
        );
    }

    Wrapper.displayName = `withPickList(${Component.displayName || Component.name})`;
    return Wrapper;
}

export {PicklistContext, withPickList};
